<template>
  <div class="tw:flex tw:flex-col tw:gap-1" :class="{ 'skeleton-play': skeleton }">
    <TextPlay v-if="label" :text="label" :for="labelFor" tag="label" size="sm" weight="semibold" />
    <slot />
    <TextPlay
      v-if="description"
      :text="description"
      class="tw:mt-1"
      color="var(--text-color)"
      size="xs"
    />
  </div>
</template>

<script lang="ts" setup>
import TextPlay from '../../atoms/TextPlay/TextPlay.vue'

withDefaults(defineProps<{
  label?: string
  labelFor?: string
  description?: string
  skeleton?: boolean
}>(), {
  label: undefined,
  labelFor: undefined,
  description: undefined,
  skeleton: false,
})
</script>
